import React, {Component} from 'react'
import './Donation.css'
import Input from '../../components/UI/Input/Input'
import { donationInputs } from '../../utilities/util'
import Button from '../../components/UI/Button/Button'
import uniqueId from 'uniqid'
import Axios from 'axios'
import Aux from '../../HOC/Auxi'
import Notification from '../UI/Notification/Notification'

class Donation extends Component{

    state = {
        isFormValid: false,
        loading: false,
        isSubmited: false,
        formInputs: {...donationInputs}, 
        notification: {
            show:false,
            data: {
                status: 'primary',
                content: null
            }
        },
    }


    formElementChangeHandler = async (event, elemName)=> {
        let formInputs = {...this.state.formInputs}
        let element = formInputs[elemName]
        element.value= event.target.value;
        element.isValid = element.validation()
        element.touched = true;
        await this.setState({formInputs: formInputs})
        await this.checkValidity()
    }

    refreshNotification = () => {
        this.setState(state => {
            return{
                ...state, 
                notification: {
                    ...state.notification, 
                    show:false
                }
            }
        })
    }

    checkValidity = async()=>{
        let  theFormIsValid = true;
        for(let elemName in this.state.formInputs){
            if(this.state.formInputs[elemName].isValid === false){
                theFormIsValid = false;
                break;
            }
        }
        await this.setState({isFormValid: theFormIsValid})
    }

    handleError = (err)=> {

    }

    onSubmit = ()=> {
        let ref = uniqueId()
        const data1 = {
            name: this.state.formInputs.name.value ?this.state.formInputs.name.value : "anonymous" , 
            email: this.state.formInputs.email.value, 
            message: this.state.formInputs.message.value ? this.state.formInputs.message.value : "anonymous"
        }
        const handler = window.PaystackPop.setup({
            key: process.env.REACT_APP_PAYSTACK_SECRET,
            email: this.state.formInputs.email.value,
            amount: this.state.formInputs.amount.value * 100,
            currency: "NGN",
            ref: ref,
            callback: (response)=>{
                console.log(response)
                if(response.status !== "success") alert("Failed transaction, try again");
                const data2 ={
                   ...data1,
                   ref: response.reference
                }
                Axios.post('https://blossomandflourish-backend.herokuapp.com/api/donate/add', data2)
                    .then(res => {
                        console.log(res)
                        const notification = {
                            show: true, 
                            data: {
                                status: 'success', 
                                content: res.data.message
                            }
                        }
                        this.setState({formInputs: {...donationInputs }, notification})
                    })
                    .catch(err => {
                        if(err.response){
                            console.log(err.response.data)
                            const notification = {
                                show: true, 
                                data: {
                                    status: 'error', 
                                    content: err.response.data.message
                                }
                            }
                            this.setState({notification})
                        }

                    })

            },
            onClose: function(){
                alert('window closed');
            }
          });
          handler.openIframe();
    }
    render(){
        let formElements = [];
        for(let elementName in this.state.formInputs){
            formElements.push({
                id: elementName, 
                config: this.state.formInputs[elementName]
            })
        }


        return(
            <Aux>
                <Notification
                show={this.state.notification.show} 
                data={this.state.notification.data}
                refresh={this.refreshNotification}
                />
                <div className="Donation">
                    <p className="Donation_Header">DONATION</p>

                    <p className="Donations_Thanks"> Thank you for your willingness to donate to the poor and needy.</p>
                    <p className="Donations_Required"> You may wish to add only your <strong>Email</strong> and <strong>Amount</strong> if you want the donation to be anonymous </p>

                    <div className="Donation_Form_Area">
                        <div className="Donation_Form">
                            <form onSubmit={this.onSubmitHandler}>
                                {formElements.map(elem => {
                                    return(
                                        <Input
                                            key={elem.id}
                                            elemType={elem.config.elemType}
                                            config={elem.config.config}
                                            value={elem.config.value}
                                            iconName={elem.config.iconName}
                                            errorMessage={elem.config.errorMessage}
                                            changed={(event)=>this.formElementChangeHandler(event, elem.id)}
                                            valid={elem.config.isValid}
                                            touched={elem.config.touched}
                                            label={elem.config.label}
                                        />
                                    )
                                })}
                            </form>
                            <Button name="Donate" clicked={this.onSubmit} disabled={!this.state.isFormValid} />
                        </div>
                    </div>

                    

                </div>
            </Aux>
        )
    }
}


export default Donation